import { defaultFormValues } from './defaultFormValues';
import type { FormValues } from './FormValues';
import type { Vehicle } from 'src/common/external/bambi-api/bambiApi';

export function assignDefaultFormValues(
  vehicle: Vehicle | undefined
): FormValues {
  return {
    ...defaultFormValues,
    ...(vehicle || {}),
  };
}
